import { Link } from "@tanstack/react-router";

import { Wordmark } from "@/components/shared/wordmark";
import { LoginForm } from "../components/login-form";

const LoginPage = () => (
  <main className="flex min-h-screen items-start justify-center bg-background px-4 pt-[12vh]">
    <div className="flex w-full max-w-[380px] flex-col gap-8">
      <Link to="/" aria-label="Home" className="w-fit">
        <Wordmark />
      </Link>
      <div className="flex flex-col gap-1">
        <h1 className="font-display text-[30px] font-medium leading-none tracking-[-0.02em]">Sign in</h1>
        <span aria-hidden className="mt-3 block h-0.5 w-10 bg-brand" />
      </div>
      <LoginForm />
    </div>
  </main>
);

export default LoginPage;
